import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login as apiLogin } from "../api/admin";
import { useAuth } from "../auth/AuthContext";
import { Logo } from "../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const { token, user } = await apiLogin(email, password);
      if (user.role !== "superadmin") {
        setErr("Bu panele yalnızca yöneticiler giriş yapabilir.");
        return;
      }
      login(token, user);
      nav("/", { replace: true });
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Giriş başarısız.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="brand" style={{ justifyContent: "center", marginBottom: 4 }}>
          <Logo className="brand-logo" /> <small>Admin</small>
        </div>
        <h2 style={{ margin: "4px 0 16px", textAlign: "center" }}>Yönetici Girişi</h2>
        <label>
          E-posta
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required autoFocus />
        </label>
        <label>
          Parola
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </label>
        {err && <div className="error">{err}</div>}
        <button type="submit" disabled={loading || !email.trim() || !password}>
          {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
}
